export default __webpack_public_path__ + "images/NB.7cb8895.png";